//natives
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Cookies from 'universal-cookie';
import {
    Checkbox,
    Select,
    MenuItem,
    CircularProgress
} from '@material-ui/core';
// import TagManager from 'react-gtm-module';

//components
import Alerta from '../../../../../util/snackbars/.mixins/';

// controllers
import Pessoa_controller from '../../../../../../controllers/pessoa';
import Permissao_controller from '../../../../../../controllers/permissao';
import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';

//childrens
import Columns from '../childrens/columns/.mixins';
import UsuariosLista from '../childrens/usuariosLista/.mixins';

export default class Usuarios extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();

        this.state = {
            itensTable: [],
            title: 'Liberação de acesso',
            columns: [],
            isLoading: true,
            isError: false,
            error: null,
            listaPermissoes: [],
            listaTipoRotacao: [{id:0,name:"rotacao a"},{id:1,name:"rotacao b"},{id:2,name:"rotacao c"}],
        };

        //binds
        this.setState = this.setState.bind(this);
        this.loadData = this.loadData.bind(this);
        
    }

    UNSAFE_componentWillMount() {
        this.setState({
            columns: Columns(this)
        });
        //carregamento de dados nos campos
        this.loadData(this);
        this.loadPermissao(this);
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:usuarios',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-usuarios',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela Usuário!");
    }

    renderAtivo = (value) => {
        return (
            <div align="center">
                <Checkbox
                    edge="start"
                    value={value.codigo}
                    checked={value.value}
                    tabIndex={-1}
                    disableRipple
                    onClick={()=>{this.handlerCheck(value.codigo)}}
                />
            </div>
        );
    };

    renderTipoAcesso = (value) => {
        return (
            <div align="center">
                {this.state.listaPermissoes.length == 0 &&
                    <div align="center">
                        <CircularProgress/>
                    </div>
                }
                {this.state.listaPermissoes.length > 0 &&
                    <Select
                        value={value.id_permissao}
                        onChange={(e)=>{this.handlerSelect(value.id_pessoa,e)}}
                        inputProps={{
                            name: 'permissao',
                            id: 'permissao_id',
                        }}
                    >
                        {this.state.listaPermissoes.map((permissao, i) => {     
                            return (<MenuItem key={i} value={permissao.id_md5}>{permissao.descricao}</MenuItem>) 
                        })}
                    </Select>
                }
            </div>
        );
    };

    renderTipoRotacao = (value) => {
        return (
            <div align="center">
                {this.state.listaTipoRotacao.length == 0 &&
                    <div align="center">
                        <CircularProgress/>
                    </div>
                }
                {this.state.listaTipoRotacao.length > 0 &&
                    <Select
                        value={value.id_tipoRotacao}
                        onChange={(e)=>{this.handlerSelectRotacao(value.id_pessoa,e)}}
                        inputProps={{
                            name: 'name',
                            id: 'id',
                        }}
                    >
                        {this.state.listaTipoRotacao.map((rotacao, i) => {
                            return (<MenuItem key={i} value={rotacao.id}>{rotacao.name}</MenuItem>) 
                        })}
                    </Select>
                }
            </div>
        );
    };

    handlerCheck(valor) {
        var itens = this.state.itensTable;
        var check = true;
        itens.forEach(element => {
            if (element[0].codigo == valor) {
                check = element[0].value;
                if (element[0].value == false)
                    element[0].value = true;
                else
                    element[0].value = false;
            }
        });
        this.setState({
            itensTable: itens,
            columns: Columns(this)
        });
        this.sendUsuario(this,valor,check);
    };

    handlerSelect(id_pessoa,e) {
        var itens = this.state.itensTable;
        itens.forEach(element => {
            if (element[5].id_pessoa == id_pessoa) {
                element[5].id_permissao = e.target.value
            }
        });
        this.setState({
            itensTable: itens,
            columns: Columns(this),
        });
        this.updatePermissao(this,id_pessoa,e.target.value);
    };

    handlerSelectRotacao(id_pessoa,e) {
        var itens = this.state.itensTable;
        itens.forEach(element => {
            if (element[7].id_pessoa == id_pessoa) {
                element[7].id_tipoRotacao = e.target.value
            }
        });
        this.setState({
            itensTable: itens,
            columns: Columns(this),
        });
        this.updateRotacao(this,id_pessoa,e.target.value);
    };

    async sendUsuario(props,id,check) {

        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {
            
            const body = {
                codigo: id,
                Valor: check
            };
            const o_pessoa = await Pessoa_controller.setAtivo(token,body);
            const json = JSON.parse(o_pessoa.body);
            
            if (json.status) {
                props.child.current.retorno('Alteração realizada!','success');

                // TagManager.dataLayer({
                //     dataLayer: {
                //         event: 'event',
                //         eventCategory: 'tokstok:fornecedores:usuarios',
                //         eventAction: 'callback',
                //         eventLabel: `sucesso`,
                //     }
                // });
            } else {
                throw new Error("Campos necessários não foram retornados pelo servidor!");
            }

        } catch (error) {
            props.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:usuarios',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }

    }

    async updatePermissao(props,id,id_md5_permissao) {

        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {
            const body = {
                codigo: id,
                permissoes_id_md5: id_md5_permissao
            };
            const o_pessoa = await Pessoa_controller.updatePermissao(token,body);
            const json = JSON.parse(o_pessoa.body);
            
            if (json.status) {
                props.child.current.retorno('Alteração realizada!','success');

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:usuarios',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso`,
                //     }
                // });
            } else {
                throw new Error("Campos necessários não foram retornados pelo servidor!");
            }

        } catch (error) {
            props.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:usuarios',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }

    }

    async updateRotacao(props,id_pessoa,id_tipoRotacao) {

        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {

            const body = {
                codigo: id_pessoa,
                id_tipoRotacao: id_tipoRotacao
            };
            const j_rotacao = await Pessoa_controller.updateRotacao(token,body);
            const o_rotacao = JSON.parse(j_rotacao);
            
            if (o_rotacao.status) {
                props.child.current.retorno('Alteração realizada!','success');

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:usuarios',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso`,
                //     }
                // });
            } else {
                throw new Error("Campos necessários não foram retornados pelo servidor!");
            }

        } catch (error) {
            props.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:usuarios',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }

    }

    async loadData(props) {
        
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {

            const o_pessoa = await Pessoa_controller.get(token);
            const j_pessoa = JSON.parse(o_pessoa.body);

            if (j_pessoa.status) {
                var array = [];
                j_pessoa.itens.forEach(element => {
                    //permissao
                    var per = "";
                    this.state.listaPermissoes.forEach(e => {
                        if (element.ID_MD5.includes(e.id_md5))
                            per = element.descricao;
                    });

                    array.push([
                        {
                            codigo: element.ID_PESSOA,
                            value: !(element.IN_BLOQ === "S")
                        },
                        (!(element.IN_BLOQ === "S")?"Sim":"Não"),
                        element.ID_PESSOA,
                        element.NM_PESSOA,
                        element.RET_EMAIL_PESSOA,
                        {
                            id_pessoa: element.ID_PESSOA,
                            id_permissao: element.ID_MD5
                        },
                        per,
                        // {
                        //     id_pessoa: element.ID_PESSOA,
                        //     id_tipoRotacao: 0,
                        // },
                    ]);
                });
                props.setState({
                    itensTable:array,
                    isLoading: false
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:usuarios',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso`,
                //     }
                // });
            } else {
                if (
                    j_pessoa.status == false && 
                    j_pessoa.message && 
                    j_pessoa.message.includes("Token inválido!")
                ) {
                    props.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            props.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:usuarios',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }

    }

    async loadPermissao(props) {
        
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            const o_permissao = await Permissao_controller.get(token);
            var json = JSON.parse(o_permissao.body);
            if (json.status) {
                props.setState({
                    listaPermissoes: json.itens
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:usuarios',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:lista-permissoes`,
                //     }
                // });
            } else {
                if (
                    json.status == false && 
                    json.message && 
                    json.message.includes("Token inválido!")
                ) {
                    props.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            props.child.current.retorno('Erro ao carregar dados!','error');
            var errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:usuarios',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }

    }
    
    render() {
        return (
            <div>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Usuários`}</title>
                </Helmet>
                <UsuariosLista {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    }

}